import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';

const NoticeList = ({ apiRef, columns, rows, loading, handleRowClick,columnVisibilityModel }) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <div style={{ display: 'flex', height: '590px' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          loading={loading}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          onRowClick={(params, e) => handleRowClick(e, params)}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}

        />
      </div>
    </div>
  )
}

export default NoticeList